var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-footer',{staticClass:"page-footer"},[_vm._v(" 版本号："+_vm._s(_setup.config.version)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }